export function formatRelativeTime(date: Date): string {
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffSecs = Math.floor(diffMs / 1000)
  const diffMins = Math.floor(diffSecs / 60)
  const diffHours = Math.floor(diffMins / 60)
  const diffDays = Math.floor(diffHours / 24)
  const diffWeeks = Math.floor(diffDays / 7)
  const diffMonths = Math.floor(diffDays / 30)
  const diffYears = Math.floor(diffDays / 365)

  if (diffSecs < 60) return 'now'
  if (diffMins < 60) return `${diffMins}m`
  if (diffHours < 24) return `${diffHours}h`
  if (diffDays < 7) return `${diffDays}d`
  if (diffWeeks < 4) return `${diffWeeks}w`
  if (diffMonths < 12) return `${diffMonths}mo`
  return `${diffYears}y`
}

export function normalizeWhitespace(code: string): string {
  return code
    .split(/\r\n|\r|\n/)
    .map(line => line.replace(/\s+$/, ''))
    .join('\n')
}

export function errorsAreEqual(errorsA: any[], errorsB: any[]): boolean {
  if (errorsA.length !== errorsB.length) return false
  if (errorsA.length === 0) return true
  return errorsA.every((err, i) => {
    const other = errorsB[i]
    return (
      other &&
      err.line === other.line &&
      err.message === other.message &&
      err.startColumn === other.startColumn &&
      err.endColumn === other.endColumn
    )
  })
}
